import "@iavmx/ui/estilos.css";
import * as React from "react";
import { createRoot } from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { RouterProvider } from "@tanstack/react-router";
import { ToastProveedor } from "@iavmx/ui";
import { router } from "./router";
import { SesionProveedor } from "./sesion";

const queryClient = new QueryClient({
  defaultOptions: { queries: { retry: 1, staleTime: 30_000 } },
});

createRoot(document.getElementById("raiz")!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <SesionProveedor>
        <ToastProveedor>
          <RouterProvider router={router} />
        </ToastProveedor>
      </SesionProveedor>
    </QueryClientProvider>
  </React.StrictMode>,
);
